// assets
import Load from 'assets/svg/other/loading2.svg';
import Header from 'components/dashHeader';
//css
import 'pages/styles/dashboard/Home.css';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { get, put, } from 'util/axiosLib';
import { logger } from 'util/logger';
import { getParameterByName, isEmpty, makeCancelable} from 'util/utils';
//import { Link } from "react-router-dom";
import Sidemenu from 'components/sidemenu';
//
import PickCountryNumber from 'components/pickCountryNumberAirtime';
import { useStore } from "store";

import Cancel from 'assets/icons/sm-x.svg';
import Check2 from 'assets/icons/pop-check.svg';


export default function Pay() {
  const { store, localsocket } = useStore();
  const history = useHistory();
  const [pageState, setPageState] = useState('loading');
  const [invoiceData, setInvoiceData] = useState({});
  const cancelableFetch = useRef();
  const [refresh, setRefresh] = useState(1);
  const [actionInProgress, setActionInProgress] = useState(false);

  const invoiceRef = useRef(getParameterByName('iv', history.location.search));

  const fetchReceivable = async () => {
    try {
      const token = store.token;
      const headers = {
        authorization: `${token}`,
        'Content-Type': 'application/json',
      };

      const invoiceRef = history?.location?.pathname.replace('/invoice/', '');

      if (isEmpty(invoiceRef)) {
        return setPageState('notFound');
      }

      const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/invoice/${invoiceRef}`;

      const getTransactionsReq = await get(baseUrl, headers);

      const rawTx = getTransactionsReq?.data?.data;

      setInvoiceData({ ...rawTx, lastFectched: new Date() });
      // await getCurrentRate();
      setPageState('ready');
    } catch (err) {
      if (err?.isAxiosError) {
        if (err?.response?.status === 401) {
          return localsocket && localsocket?.emit('LOGOUT');
        } else if (err?.response?.status === 403) {
          return setPageState('notFound');
        } else if (err?.response?.status === 404) {
          return setPageState('notFound');
        }
      } else {
        logger('ERROR:: ', err);
      }
      setPageState('error');
      // setTransactionError(String(err))
    }
  };

  const cancelReceivable = async tradeId => {
    if (!tradeId) return; // show some notification here
    try {
      const baseUrl = process.env.REACT_APP_API_ENDPOINT;

      const token = store.token;
      const headers = {
        authorization: `${token}`,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      };

      const url = `${baseUrl}/wallet/invoice/${tradeId}/cancel`;

      setActionInProgress(true);

      await put(url, {}, headers);

      //  refetch data
      refresh();

      setActionInProgress(false);
    } catch (err) {
      setActionInProgress(false);
      logger(err);
    }
  };

  const handleCancel = async () => {
    const invoiceRef = history?.location?.pathname.replace('/invoice/', '');

    if (isEmpty(invoiceRef)) {
      return;
    }
    await cancelReceivable(invoiceRef);
    setRefresh(Math.random() * 8765);
  };

  const payType = invoiceRef ? 'invoice' : 'direct';

  useEffect(() => {
    if (payType === 'invoice') {
      cancelableFetch.current = makeCancelable(fetchReceivable());
    }

    return () => {
      cancelableFetch.current && cancelableFetch.current.cancel();
    };
    // eslint-disable-next-line
  }, [refresh, invoiceRef]);

  if(false) return <NotFound />

  return (
    <>
      <Header />
      <PayCard
        invoiceData={invoiceData}
        pageState={pageState}
        setInvoiceData={setInvoiceData}
        setPageState={setPageState}
        handleCancel={handleCancel}
        actionInProgress={actionInProgress}
      />
    </>
  );
}

var NotFound = () => {
  const { store } = useStore();
  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-center">
          <h2 className="text-center">The page you are looking for cannot be found.</h2>
        </div>

        <div className="mt-8 gap-6">
          <Link to={store.isLoggedIn ? `/dashboard/wallet` : '/'} className="green bold">
            Go to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export function PayCard() {
  const [popState, setPopState] = useState('');
  const [selectedWallet] = useState('');
  const [selectedCurrency] = useState('BTC');
  const [errorMessage] = useState('');
  const [incorrectError] = useState('');
  const [walletBalance] = useState(500);

  const handleSubmit = () => {
    setPopState('paySuccess');
  };
  const handleSummary = () => {
    setPopState('showSummary');
  };
  const handleInputChange = () => {};
  const handleCoinChange = () => {};

  return (
    <>
      <Sidemenu currentPage={'MerchantPay'} />
      <Header />
      <StyledDiv>
        <div>
          {popState === 'paySuccess' ? (
            <div>
              <div className="overlay animate__animated animate__fadeIn "></div>
              <section className="popup">
                <div className="popup-box animate__animated animate__slideInDown">
                  <div className="popup-img">
                    <img
                      className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                      src={Check2}
                      alt=""
                    />
                  </div>
                  <h2>
                    <p>
                      ₦{5000}
                      <br />
                      <span className="sm-popup-txt">Payment Successfull</span>{' '}
                    </p>
                  </h2>
                  <button onClick={() => setPopState('')} className="popup-close-btn">
                    Close
                  </button>
                </div>
              </section>
            </div>
          ) : null}

          {popState === 'showSummary' ? (
            <div>
              <div className="overlay animate__animated animate__fadeIn "></div>
              <section className="summaryclicked">
                <div className="summaryclicked-box animate__animated animate__slideInUp">
                  <div className="sc-top">
                    <h2 className=""> Summary</h2>
                    <img onClick={() => setPopState('')} src={Cancel} alt="close" />
                  </div>
                  <div className="sc-items">
                    <p className="sc-item-title">Make Payment From</p>
                    <p>{selectedWallet.toUpperCase()} Wallet</p>
                  </div>

                  <div className="sc-items-last">
                    <p className="sc-item-title">Amount in {selectedWallet.toUpperCase()}</p>
                    <p>
                      <span>{Number(5000).toLocaleString()} </span>{' '}
                    </p>
                  </div>

                  <div className="sc-items-last">
                    <p className="sc-item-title"> Amount in {selectedCurrency.toUpperCase()}</p>
                    <p>
                      <span>{Number(500).toLocaleString()} </span>{' '}
                    </p>
                  </div>

                  {/* <div className="sc-items-last">
                          <p className="sc-item-title"> Phone Number</p>
                          <p>
                              <span>
                              {localStorage.getItem("countryCodeA")+this.state.phoneNo}{" "}
                              </span>{" "}
                          </p>
                      </div> */}
                  <button id="summaryBtn" onClick={handleSummary} className="summaryclicked-btn">
                    Submit
                  </button>
                  <div id="loadla" className="load-aa">
                    <img src={Load} alt="loading" />
                  </div>
                  <div id="error-info" className="error-info animate__animated animate__fadeIn">
                    <p>{errorMessage}</p>
                  </div>
                </div>
              </section>
            </div>
          ) : null}

          <section className="home">
            <div className="home-container">
              <div className="home-buy-content">
                <h1> Authorize Payment </h1>
              </div>
              <div id="error-info2" className="err-auth zindex animate__animated animate__slideInDown">
                <p>
                  <strong>{incorrectError}</strong>
                </p>
              </div>
              <div className="hw-box">
                <p className="hw-p-sp0">Select the wallet to debit.</p>
                <form onSubmit={handleSubmit} className="hw-form">
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">Select Wallet</p>
                    <select
                      className="hw-drop"
                      name="selectedWallet"
                      onChange={handleCoinChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value={process.env.REACT_APP_COIN_A}>
                        {' '}
                        {process.env.REACT_APP_COIN_A.toUpperCase()}{' '}
                      </option>
                      <option value={process.env.REACT_APP_COIN_B}>
                        {' '}
                        {process.env.REACT_APP_COIN_B.toUpperCase()}{' '}
                      </option>
                      <option value={process.env.REACT_APP_COIN_C}>
                        {' '}
                        {process.env.REACT_APP_COIN_C.toUpperCase()}{' '}
                      </option>
                      <option value={process.env.REACT_APP_COIN_D}>
                        {' '}
                        {process.env.REACT_APP_COIN_D.toUpperCase()}{' '}
                      </option>
                      <option value={process.env.REACT_APP_COIN_E}> cUSD</option>
                      <option value={process.env.REACT_APP_COIN_F}>
                        {' '}
                        {process.env.REACT_APP_COIN_F.toUpperCase()}{' '}
                      </option>
                      <option value={process.env.REACT_APP_COIN_G}>
                        {' '}
                        {process.env.REACT_APP_COIN_G.toUpperCase()}{' '}
                      </option>
                      <option value={process.env.REACT_APP_COIN_H}>{process.env.REACT_APP_COIN_H.toUpperCase()}</option>
                      <option value={process.env.REACT_APP_COIN_I}>{process.env.REACT_APP_COIN_I.toUpperCase()}</option>
                    </select>
                  </div>
                  <p className="coin-bal ">
                    {/* <span className="right-m0"> Coin balance:  </span> */} {Number(walletBalance).toFixed(8)}{' '}
                  </p>
                  <div className="hw-inputs">
                    <p className="hw-p-sp2"> Select Currency </p>
                    <select className="hw-drop" name="selectedCurrency" onChange={handleInputChange}>
                      <option value="ngn">Nigerian Naira (NGN)</option>
                      <option value="ghs">Ghana Cedi (GHS)</option>
                    </select>
                  </div>
                  <div className="hw-inputs2">
                    <p className="hw-p-sp1"> Phone Number</p>
                    <PickCountryNumber />
                    <input
                      type="text"
                      name="phoneNo"
                      placeholder="Phone number without the first zero"
                      maxLength="13"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">Amount</p>
                    <input type="text" name="airtimeAmount" placeholder="Amount" onChange={handleInputChange} />
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">Amount in {selectedCurrency.toLocaleUpperCase()}</p>
                    <input type="text" placeholder="Amount" disabled value={Number(500).toLocaleString()} />
                  </div>

                  <button id="actionBtn" className="hw-btn-a e-disable" type="submit">
                    Confirm Payment
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      </StyledDiv>
    </>
  );
};

var StyledDiv = styled.div``;
